import {Route} from "react-router-dom";
import EstimationFragment from "../../layout/estimation/EstimationFragment.jsx";
import ExpenditureMainFragment from "../../layout/expenditure/ExpenditureMainFragment.jsx";
import ItineraryMainFragment from "../../layout/itinerary/ItineraryMainFragment.jsx";
import TripMainFragment from "../../layout/TripMainFragment.jsx";
import Dashboard from "../Dashboard.jsx";
import Home from "../Home.jsx";


function RoutePath(path, component, title, exact = false, isPrivate = false) {
	  return {path, component, title, exact, isPrivate};
}


export const HOME = new RoutePath("/", Home, "Home", true);
export const DASHBOARD = new RoutePath("/dashboard", Dashboard, "Dashboard", true);
// export const WEBAPP = new RoutePath("/webapp", APXWebApp, "WebApp", true);
// export const ABOUT = new RoutePath("/about", "About", "About", true);


export const webappName = "APXTripp";

export const webappPaths = {
	  root: "/",
	  itinerary: "/itinerary",
	  expenditure: "/expenditure",
	  estimation: "/estimation"
};
export const webappRoutes = [
	  <Route path={webappPaths.root} key={webappPaths.root} exact component={TripMainFragment}/>,
	  <Route path={webappPaths.itinerary} key={webappPaths.itinerary} component={ItineraryMainFragment}/>,
	  <Route path={webappPaths.expenditure} key={webappPaths.expenditure} component={ExpenditureMainFragment}/>,
	  <Route path={webappPaths.estimation} key={webappPaths.estimation} component={EstimationFragment}/>
];